// extracted by mini-css-extract-plugin
export default {"address":"icons_address__y4zXZ","phone":"icons_phone__zYHJz","email":"icons_email__0ngSI","hide":"icons_hide__8-H-i","show":"icons_show__Stqkh"};